import React, { useEffect, useState } from 'react';
import classes from './HomePage2.module.css';
import { upcomingMatchesApi, userMatchesApi } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import SmallLoader from '../../component/SmallLoader';
import { removeUserDetails } from '../../store/slices/userSlice';
import Header2 from '../../component/NewComponents/Header2';
import MatchLayoutNew from '../../component/NewComponents/MatchLayoutNew';
import { useTranslation } from 'react-i18next';

const HomePage2 = () => {
    const [upcomingMatches, setUpcomingMatches] = useState([]);
    const [userMatches, setUserMatches] = useState(null);
    const { userDetails } = useSelector(state => state.persisted?.userSlice);
    const navigate = useNavigate();
    const [userMatchesLoading, setUserMatchesLoading] = useState(true);
    const [loading, setLoading] = useState(true);
    const [loader, setLoader] = useState(true);
    const dispatch = useDispatch();

    const {t}=useTranslation();

    const fetchUserMatches = async (load) => {
        try {
            if (load) setUserMatchesLoading(true);
            setLoader(true);
            const response = await userMatchesApi(userDetails?.token);
            console.log(response, 'response...');
            setUserMatches({
                fantasy: response?.data?.fantasy,
                prediction: response?.data?.prediction
            });
            setUserMatchesLoading(false);
            setLoader(false);
        } catch (error) {
            setUserMatchesLoading(false);
            setLoader(false);
            toast.error(t("20"));
            console.log(error, 'error---');
        }
    }

    const fetchUpcomingMatches = async (load) => {
        try {
            if (load) setLoading(true);
            setLoader(true);
            const response = await upcomingMatchesApi(userDetails?.token);
            setUpcomingMatches(response?.data);
            console.log(response, 'response...');
            setLoading(false);
            setLoader(false);
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("48"));
                navigate('/');
            } else {
                setLoading(false);
                setLoader(false);
                toast.error(t("20"));
            }
        }
    }

    useEffect(() => {
        fetchUserMatches(true);
        fetchUpcomingMatches(true);
    }, []);

    useEffect(() => {
        if (!loader) {
            const intervalId = setInterval(() => {
                if (!document.hidden) {
                    fetchUserMatches();
                    fetchUpcomingMatches();
                }
            }, 10000);
            return () => clearInterval(intervalId);
        }
    }, [loader]);

    return (
        <div className={classes.page}>
            <Header2 active={0} />

            <main className={classes.main}>
                {/* Hero bar */}
                <div className={classes.heroBar}>
                    <div className={classes.heroText}>
                        <span className={classes.heroEyebrow}>{t("49")}</span>
                        <h1 className={classes.heroTitle}>{t("50")} <em>{t("51")}</em></h1>
                    </div>
                    <div className={classes.heroMeta}>
                        <span className={classes.heroCount}>
                            {upcomingMatches.length} <span>{t("52")}</span>
                        </span>
                        <span className={classes.liveTag}>
                            <span className={classes.liveDot} />
                            {t("53")}
                        </span>
                    </div>
                </div>

                {/* Content */}
                {(loading || userMatchesLoading) ? (
                    <div className={classes.loaderWrap}>
                        <SmallLoader />
                        <p className={classes.loaderText}>{t("54")}</p>
                    </div>
                ) : (
                    <div className={classes.matchGrid}>
                        {upcomingMatches.length > 0 ? (
                            upcomingMatches.map((match, index) => (
                                <MatchLayoutNew
                                    match={match}
                                    key={index}
                                    index={index}
                                    fantasy_match_joined={
                                        userMatches?.fantasy?.filter(d => d?.match_fixture_id == match?.match_fixture_id).length > 0
                                    }
                                    prediction_match_joined={
                                        userMatches?.prediction?.filter(d => d?.match_fixture_id == match?.match_fixture_id).length > 0
                                    }
                                />
                            ))
                        ) : (
                            <div className={classes.emptyState}>
                                <span className={classes.emptyEmoji}>⚽</span>
                                <p className={classes.emptyTitle}>{t("55")}</p>
                                <p className={classes.emptySub}>{t("56")}</p>
                            </div>
                        )}
                    </div>
                )}
            </main>
        </div>
    );
}

export default HomePage2;